import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { SocialProofBar } from '../components/SocialProofBar';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { EliteSection } from '../components/EliteSection';
import { BonusSection } from '../components/BonusSection';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="w-full min-h-screen bg-[#06291f]" data-id="element-264" data-mp="2g0f7m1ywhfzz">
      <HeroSection data-id="element-265" data-mp="qjxnsj7vh9sw" />
      <SocialProofBar data-id="element-266" data-mp="qlihy7q9yqq8" />
      <ProblemSection data-id="element-267" data-mp="qkzbpo9zlqs1" />
      <SolutionSection data-id="element-268" data-mp="llmeqapej3bq" />
      <WhatYouGet data-id="element-269" data-mp="lm6061e9g9ui" />
      <EliteSection data-id="element-270" data-mp="lmnzj6w7z46n" />
      <BonusSection data-id="element-271" data-mp="lnh17tgbn3hx" />
      <PricingSection data-id="element-272" data-mp="lnz6tgoviu2i" />
      <GuaranteeSection data-id="element-273" data-mp="2zjgqwyk6a6e2" />
      <FAQSection data-id="element-274" data-mp="2zjyj9k3ps0gp" />
      <FinalCTA data-id="element-275" data-mp="2zkhzmwdpugsm" />
      <Footer data-id="element-276" data-mp="2zguae9fb0gjp" />
    </main>;
}